<template>
  <div class="calc-btns">
    <v-btn
      v-for="routeBtn in routeHandlerButton()"
      :key="routeBtn.text"
      :hidden="routeBtn.hidden"
      :class="routeBtn.class"
      :color="routeBtn.color"
      :disabled="routeBtn.disabled"
      :loading="routeBtn.loading"
      outline
      flat
      @click.stop="$emit(routeBtn.onClick)"
    >
      {{ routeBtn.text }}
      <template v-if="routeBtn.showSpinner" v-slot:loader>
        <span class="calculation-spinner">
          <v-icon light>cached</v-icon>
        </span>
      </template>
    </v-btn>
    <template v-if="nullTimes && routeEditMode">
      <v-btn
        class="routeBtn specBtn"
        color="green"
        round
        dark
        @click.stop="$emit('save-clicked')"
      >
        {{ isSavedRoute ? "Update" : "Save" }} Route
      </v-btn>
    </template>
    <template v-else>
      <template v-if="selectedRoute && !checkRouteTime && !routeEditMode">
        <v-btn
          v-if="stateButton"
          :color="stateButton.color"
          class="routeBtn specBtn"
          :class="stateButton.class"
          round
          dark
          @click.stop="$emit(stateButton.callback, stateButton.isReminder)"
        >
          {{ stateButton.text }}
        </v-btn>
      </template>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import colors from '../../../../scss/_colors.scss'
import {
  isPastRoute,
  isSendReminderActive
} from '../../../../utils/routeUtils'

export default {
  props: {
    isCalculating: {
      type: Boolean,
      required: true
    },
    disableCalculate: {
      type: Boolean,
      required: true
    },
    hideCalculate: {
      type: Boolean,
      required: true
    },
    nullTimes: {
      type: Boolean,
      required: true
    }
  },

  computed: {
    ...mapState('common', ['selectedRoute']),
    ...mapState('agent', ['routeEditMode']),

    isSavedRoute() {
      return this.selectedRoute && this.selectedRoute.state === 'saved'
    },

    isPendingRoute() {
      return this.selectedRoute && this.selectedRoute.state === 'pending'
    },

    isNotSavedType() {
      return this.selectedRoute && this.selectedRoute.state !== 'saved'
    },

    checkRouteTime() {
      return isPastRoute(this.selectedRoute)
    },

    stateButton() {
      if (this.selectedRoute) {
        switch (this.selectedRoute.state) {
          case 'saved':
            return {
              text: 'Request Showing',
              color: colors.pending,
              callback: 'request-showing'
            }
          case 'confirmed':
            return {
              text: 'Send Schedule',
              color: colors.saved,
              callback: 'send-schedule'
            }
          case 'scheduled':
            return isSendReminderActive(this.selectedRoute)
              ? {
                text: 'Reminder Sent',
                color: colors.scheduled,
                class: 'disabled-state',
                callback: 'send-schedule',
                isReminder: true
              }
              : {
                text: 'Send Reminder',
                color: colors.scheduled,
                callback: 'send-schedule'
              }
          default:
            return null
        }
      }
      return null
    }
  },

  methods: {
    routeHandlerButton() {
      return [
        {
          text: 'Calculate',
          color: 'primary',
          class: 'routeBtn calcBtn',
          onClick: 'calculate',
          disabled: this.disableCalculate,
          loading: this.isCalculating,
          hidden: this.hideCalculate,
          showSpinner: true
        },
        {
          text: 'Cancel',
          color: 'red',
          class: 'routeBtn calcBtn',
          onClick: 'cancel-route',
          hidden: this.isPendingRoute || !this.hideCalculate
        },
        {
          text: 'Clear',
          color: 'green',
          class: `routeBtn ${this.isPendingRoute ? 'calcBtn' : 'clearBtn'}`,
          onClick: 'new-route-page'
        }
      ]
    }
  }
}
</script>

<style lang="sass" scoped>
@import "@/scss/_animations.scss"

.calc-btns
  display: grid
  grid-template-columns: 1fr 1fr 1fr
  grid-template-areas: "clear calc save"
  margin: 2rem

.specBtn
  grid-area: save
  margin: 6px auto !important

.calcBtn
  grid-area: calc

.routeBtn
  padding: 0 10% !important
  font-size: 1.2rem
  width: 80%
  .v-btn__content
    text-transform: capitalize !important
    color: $hwayzWhite !important
    font-weight: 400 !important

.clearBtn
  grid-area: clear

.calculation-spinner
  animation: loader 1s infinite
  display: flex
</style>
